import axiosConfig from "./axiosConfig";

export interface GlobalStateRecord {
  id: string;
  type: string;
  name: string;
  value: string;
  siteCount: number;
  orgCount: number;
}

export interface GlobalStateResponse {
  globalState: GlobalStateRecord[];
}

const getGlobalState = async (
  authToken: string,
  type?: string
): Promise<GlobalStateResponse> => {
  const params = type ? `?type=${encodeURIComponent(type)}` : "";
  const { data } = await axiosConfig.get(`/global-state${params}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default getGlobalState;
